import React, { Component } from 'react';
import PropTypes from "prop-types";
import {BeatLoader} from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import {putWithHeadersResponse} from './../../../server/actions';
import { _addNotification, _addNotificationError } from '../../../server/util';

const styles={
    tableHeader:{
        lineHeight: '29px',
        backgroundColor: '#d2d7d4',
        color: '#757576'
    },
    tableBodyRow:{
        marginTop: '5px',
        marginBottom: '5px',
        lineHeight: '35px',
        borderBottom: 'solid 1px #d2d7d4'
    }
}
class Settings extends Component {
    constructor(props){
        super(props);
        this.state={
            schoolObject:{},
            students:[],
            loading:false
        }
    }
    componentWillMount=()=>{
      const {schoolObject, students}=  this.context.router.route.location.state;
      const studList=JSON.parse(JSON.stringify(students));
      this.setState({schoolObject:{...schoolObject}, students:studList.map(s=>{
        s.oldDefaultNotifyEmail=s.defaultNotifyEmail;
        // Students without a saved preference default to "Both emails"; oldDefaultNotifyEmail
        // keeps the raw value so the default gets persisted on submit.
        s.defaultNotifyEmail=s.defaultNotifyEmail||'Both emails';
        return s;
    })})
    }
    componentDidMount=()=> {
        this._notificationSystem = this.refs.notificationSystem;
    }
    onSubmit=()=>{
        const {students} =this.state
        const changedList=students.filter((std)=>std.oldDefaultNotifyEmail!=std.defaultNotifyEmail).map(rec=>{
            return {
                "studentUserId": rec.id,
                "notificationPreference": rec.defaultNotifyEmail        
            }
        });
        if(changedList.length>0){
            this.setState({loading: true});
            let headers = {
                'Content-Type': 'application/json'
            };
            const url=`/manageStudents/preferences?access_token=`;
            putWithHeadersResponse(url,JSON.stringify(changedList), headers)
                .then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response.json();
                }).then(data => { 
                    console.log("Loading Menu Failed", data);              
                    this.setState({loading: false}); 
                    _addNotification(data.statusMessage,this);
                    setTimeout(() =>
                        (window.location.replace('/parent')), 2000);
            }).catch(error => {
                console.log("Loading Menu Failed", error);
                _addNotificationError(error,this);
                this.setState({loading: false});
            });

        }else{
            //_addNotificationError('',this);
        }
    }
    render() {
        const {schoolObject, students, loading}=this.state;
        return (
            <section className="full-width clearfix">
                <NotificationSystem ref="notificationSystem"/>
                <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container " style={{    marginTop: '12px'}}> 
                    <div className="sectionTitle">
                        <h2>
                            <span>{`Settings for ${schoolObject.schoolName}`}</span>
                            <button className="pull-right btn bg-color-4" style={{margin:'0px',color:'#ffffff'}} onClick={(e) => {
                                e.preventDefault();
                                let _self=this;
                                _self.context.router.history.goBack() ;
                            }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
                        </h2>
                    </div> 
                    <div className='row'>
                        <div className='col-md-offset-3 col-md-6'>
                            <div className='panel panel-primary'>
                                <div className="panel-heading">Email notification preference</div>
                                <div className="panel-body" style={{paddingTop:'0px'}}>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className='row' style={styles.tableHeader}>
                                                <div className='col-md-1'><strong>S.No</strong></div>
                                                <div className='col-md-6'><strong>Student Name</strong></div>
                                                <div className='col-md-5'><strong>Email preference</strong></div>
                                            </div>
                                            {
                                                (students||[]).map((stud,i)=>{
                                                    return <div className='row' style={styles.tableBodyRow}>
                                                    <div className='col-md-1'>{`${i+1}.`}</div>
                                                    <div className='col-md-6'><strong>{`${stud.firstName||''} ${stud.lastName||''}`}</strong></div>
                                                    <div className='col-md-5'>
                                                        <select className='form-control form-control-sm' value={stud.defaultNotifyEmail} onChange={(e)=>{
                                                            const studentList=[...this.state.students];
                                                            studentList[i].defaultNotifyEmail=e.target.value;
                                                            this.setState({students:[...studentList]})
                                                        }}>
                                                            <option value="Primary email">Primary email</option>
                                                            <option value="Alternate email">Alternate email</option>
                                                            <option value="Both emails">Both emails</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                })
                                            }
                                            </div>
                                    </div>
                                </div>
                                <div className="panel-footer text-right">
                                    <button type='button' className='btn btn-danger btn-xs' style={{margin:'0px', marginRight:'5px'}} onClick={()=>{
                                        this.context.router.history.push('/parent');
                                    }}>Cancel</button>
                                    <button type='button' className='btn btn-success btn-xs' style={{margin:'0px'}} disabled={loading} onClick={()=>this.onSubmit()}>Save</button>
                                    
                                </div>
                            </div>
                        </div>
                    </div>     
                </div>
            </section>
        );
    }
}
Settings.contextTypes = {
    router: PropTypes.object.isRequired
}

export default Settings;


// WEBPACK FOOTER //
// ./src/components/Parent/settings/index.js